import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import type { ContractRouterClient } from '@orpc/contract'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import type { AdminContract } from '@sirius/contracts/admin'

/** Typed client for every procedure of the admin contract. */
export type AdminClient = ContractRouterClient<AdminContract>

/**
 * oRPC client for the admin API. Procedures live under `/rpc` (see
 * `apps/backend/README.md`). Every call sends the Better Auth session cookie,
 * which lives on the API's origin, so cookies go cross-origin.
 */
export function createAdminClient(apiUrl: string): AdminClient {
  const link = new RPCLink({
    url: `${apiUrl}/rpc`,
    fetch: (request, init) =>
      globalThis.fetch(request, { ...init, credentials: 'include' }),
  })

  return createORPCClient(link)
}

/** TanStack Query options (`queryOptions`, `mutationOptions`, keys) per procedure. */
export function createAdminQueryUtils(client: AdminClient) {
  return createTanstackQueryUtils(client)
}
